export enum TipoItem {
  MERCADORIA = 'MERCADORIA',
  SERVICO = 'SERVICO',
}
